var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.828,
    height: 12.05,
    viewBox: "0 0 13.828 12.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "/* stylelint-disable */.a{fill:#005fec;stroke:#005fec;stroke-width:0.5px;}/* stylelint-enable */"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.14,5.02a.43.43,0,0,0,0,.622L6.316,8.308a.541.541,0,0,0,.712,0L9.2,5.642a.44.44,0,1,0-.622-.622L7.116,6.8V.444a.444.444,0,0,0-.889,0V6.8L4.762,5.02a.43.43,0,0,0-.622,0Zm8.752,2.088h-.025a.419.419,0,0,0-.419.419c0,.009,0,.018,0,.026v3.108H.9V7.552c0-.008,0-.016,0-.025a.419.419,0,0,0-.419-.419H.427a.419.419,0,0,0-.419.419c0,.009,0,.018,0,.027v3.553c0,.008,0,.016,0,.025a.419.419,0,0,0,.419.419H12.917a.419.419,0,0,0,.419-.419c0-.009,0-.018,0-.026V7.552a.445.445,0,0,0-.444-.444Z",
    transform: "translate(0.242 0.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.0bf18c41ff2f2cbda5ff9af158151064.svg";
export { ForwardRef as ReactComponent };